module.exports = __webpack_public_path__ + "static/img/1081_small.e602a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1081_small.png
// module id = dtm0
// module chunks = 1